// Группы тегов окна тегов записи (ТЗ us/11144, п. 4.3–4.4). Бэк отдаёт теги
// одним списком без группы, поэтому канал обращения и стоимость отбираются по
// именам — тем же, что раньше стояли в захардкоженном окне «Добавить теги».
export const CHANNEL_TAG_NAMES = [
  'ВКонтакте',
  'ВК реклама',
  'Рекомендация',
  'Яндекс карты',
  'Instagram',
  'Яндекс реклама',
  'Сайт',
  '2ГИС',
  'Avito',
  'Блоггер',
  'Партнеры',
  'Zoon',
  'Telegram',
  // Так тег называется в организациях сейчас; без него чекбокс уходил из
  // канала обращения в отдельную группу (issue/11351).
  'Telegram Bot',
  'Рассылка',
  'Пересадка',
  'Flamp',
] as const;

export const PRICE_TAG_NAMES = ['Акция', 'Прайс'] as const;

// Тип клиента бэк отдаёт строкой: new — новый клиент, old — повторный
// (комментарий Соболева 17.09.2026, ModelRecordProperties.ClientType).
// В окне показываются все варианты, как у типа записи (issue/11351).
export const CLIENT_TYPES: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'new', label: 'Новый' },
  { value: 'old', label: 'Повторный' },
];

export const RECORD_TAGS_MODAL_PF = 'RecordTagsModal';
